export type EngagementPath = {
  name: string
  summary: string
  typicalWork: string[]
}

export const engagementPaths: EngagementPath[] = [
  {
    name: 'New or rebuilt website',
    summary:
      'For companies replacing a site that no longer reflects how they sell, or launching a presence that has to earn attention from the start.',
    typicalWork: [
      'Audience, offer, and buying-path review',
      'Site and content architecture',
      'Custom design and build',
      'Content migration, redirects, and launch QA',
      'Managed hosting, SSL, and monitoring',
    ],
  },
  {
    name: 'Ecommerce and custom workflows',
    summary:
      'For businesses whose catalog, pricing rules, account structure, or order handling has outgrown what a standard store setup can express.',
    typicalWork: [
      'Catalog, variant, and configuration modeling',
      'Customer, account, and wholesale pricing',
      'Checkout, tax, shipping, and payment setup',
      'Order, inventory, and fulfillment integrations',
      '0% WebsiteForge transaction fees',
    ],
  },
  {
    name: 'Ongoing growth and support',
    summary:
      'For companies that want the system watched, reported on, and improved every month rather than revisited every few years.',
    typicalWork: [
      'Search, content, and landing-page work',
      'Google Ads and conversion-tracking support',
      'Content and configuration changes',
      'Reporting tied to calls, forms, and orders',
      'New integrations and automation as needs change',
    ],
  },
]

export const scopeFactors: string[] = [
  'Content volume and migration',
  'Custom functionality and workflows',
  'Catalog and pricing complexity',
  'Integrations and data movement',
  'Timeline and launch requirements',
  'Ongoing management needs',
]
